import FormularioFacturas from '../../components/facturas/FormularioFacturas';

const ListadoFacturas = () => (
  <div>
    <div style={{ marginBottom: '16px' }}>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#111827', margin: 0 }}>Facturas</h1>
      <p style={{ color: '#9ca3af', marginTop: '2px', marginBottom: 0, fontSize: '0.8rem' }}>
        Gestiona y busca facturas del sistema
      </p>
    </div>
    <FormularioFacturas />
  </div>
);

export default ListadoFacturas;
